import { BsyUtils } from "./Utils";

export function getChromeVersion() {
    var userAgent = navigator.userAgent.toLowerCase();
    var regex = new RegExp('chrome\\/([^\\d. ]+)');
    var match = userAgent.match(regex);
    if (match && match.length > 1) {
        return match[1]; // 返回版本号
    }
    return null; // 没有找到版本号
}

export function getSafariVersion() {
    var userAgent = navigator.userAgent.toLowerCase();
    var regex = new RegExp('safari\\/([^\\d. ]+)');
    var match = userAgent.match(regex);
    if (match && match.length > 1) {
        return match[1]; // 返回版本号
    }
    return null; // 没有找到版本号
}



export function getFirefoxVersion() {
    var userAgent = navigator.userAgent.toLowerCase();
    var regex = new RegExp('firefox\\/([^\\d. ]+)');
    var match = userAgent.match(regex);
    if (match && match.length > 1) {
        return Number(match[1]); // 返回版本号
    }
    return null; // 没有找到版本号
}

// 获取浏览器信息，如果遇到异常
export function getBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.indexOf('firefox') > -1) {
        return 'Firefox';
    } else if (userAgent.indexOf('edge') > -1 || userAgent.indexOf('edg/') > -1) {
        return 'Edge';
    } else if (userAgent.indexOf('opr') > -1 || userAgent.indexOf('opera') > -1) {
        return 'Opera';
    } else if (userAgent.indexOf('chrome') > -1 && userAgent.indexOf('safari') > -1 && userAgent.indexOf('edge') === -1 && userAgent.indexOf('opr') === -1) {
        return 'Chrome';
    } else if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1) {
        return 'Safari';
    } else if (userAgent.indexOf('trident') > -1) {
        return 'Internet Explorer';
    } else if (userAgent.indexOf('msie') > -1) {
        return 'Internet Explorer';
    } else {
        BsyUtils.errorReport({ "function": "getBrowser" })
        return 'Unknown';
    }
}

